export default {
  type: {
    type: String,
    required: false,
  },
  currentStepTexts: {
    type: Object,
    required: true,
  },
  currentStepOptions: {
    type: Array,
    required: false,
  },
  nextStepCallback: {
    type: Function,
    required: true,
  },
  previousStepCallback: {
    type: Function,
    required: false,
  },
  showFieldErrorMessage: {
    type: Function,
    required: true,
  },
  inputCallback: {
    type: Function,
    required: true
  },
  getNamedFieldInputData: {
    type: Object,
    required: true,
  },
  newslettersData: {
    type: Array,
    required: false,
  },
  resetSignupForm: {
    type: Function,
    required: true,
  },
  imageSource: {
    type: String,
    required: false,
  },
  imageAltText: {
    type: String,
    required: false,
  },
  // this should be the output of a computed value in the parent
  stepCounterText: {
    type: String,
    required: true,
  },
  labels: {
    type: Object,
    required: false,
  },
  hasPreviousStep: {
    type: Boolean,
    required: false,
    default: false,
  },
  displayInputError: {
    type: Boolean,
    required: false,
    default: false,
  },
  currentStep: {
    type: Number,
    required: false,
    },
    redirectUrl: {
        type: String,
        required: false
    },
    alwaysShowCprField: {
        type: Boolean,
        default: false,
        required: false
    }
}
